import { useMutation, useQuery } from "@apollo/client";
import { message } from "antd";
import {
  ApplicantProfileCitizenshipEditContainerApplicantUserDocument,
  ApplicantProfileCitizenshipEditContainerApplicantUserUpdateDocument,
  ApplicantUserCitizenshipInput,
} from "../../../../generated";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { lookupCountryQuery } from "./profile-citizenship-country-query";
import { useNavigate } from "react-router-dom";
import { ProfileCitizenshipEdit } from "./profile-citizenship-edit";
import { getItem } from "../../../shared/local-storage";

export const ProfileCitizenshipEditContainer = () => {
  const navigate = useNavigate();
  const applicantUserId = getItem('applicantUserId');

  const {
    data: countryCitizenshipData,
    loading: countryCitizenshipDataLoading,
    error: countryCitizenshipError,
  } = useQuery(ApplicantProfileCitizenshipEditContainerApplicantUserDocument, {
    variables: {
      applicantUserId,
    },
  });

  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const [applicantUserUpdate] = useMutation(ApplicantProfileCitizenshipEditContainerApplicantUserUpdateDocument);

  const handleSave = async (data: ApplicantUserCitizenshipInput) => {
    console.log("data: ", data);
    try {
      await applicantUserUpdate({
        variables: {
          input: {
            id: applicantUserId,
            applicantUserDetails: {
              personalInformation: {
                citizenship: data,
              }
            }
          },
        },
      });
      message.success("Citizenship details updated");
      handleEdit();
    } catch (error) {
      message.error(`Error Updating Citizenship: ${JSON.stringify(error)}`);
    }
  };

  const handleEdit = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/view");
    navigate(newPath);
  };

  return (
    <ComponentQueryLoader
      hasData={
        countryData?.countries?.eventPayload?.countries &&
        countryCitizenshipData?.applicantUser?.personalInformation?.citizenship
      }
      loading={countryLoading || countryCitizenshipDataLoading}
      error={countryError || countryCitizenshipError}
      hasDataComponent={
        <ProfileCitizenshipEdit
          citizenship={
            countryCitizenshipData?.applicantUser?.personalInformation
              ?.citizenship
          }
          countries={countryData?.countries?.eventPayload?.countries}
          onCancel={handleEdit}
          onSave={handleSave}
        />
      }
    />
  );
};
